// frontend/src/app/services/admin-auth.interceptor.ts
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminAuthService } from './admin-auth.service';

const ADMIN_API_PREFIX = `${environment.apiUrl}/admin/`;
const ADMIN_LOGIN_URL = `${environment.apiUrl}/admin/auth/login`;

/** Ajoute X-Admin-Token aux appels `/api/admin/*` ; session expirée → retour à la page de connexion admin. */
export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(ADMIN_API_PREFIX) || req.url === ADMIN_LOGIN_URL)
    return next(req);

  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);
  const token = adminAuth.token();
  const authorized = token
    ? req.clone({ setHeaders: { 'X-Admin-Token': token } })
    : req;

  return next(authorized).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        adminAuth.logout();
        router.navigate(['/admin/login']);
      }
      return throwError(() => error);
    }),
  );
};
